import {gsap, smoother, ScrollTrigger} from "../Utility/gsap";

export const InitThreeCircleInfographic = () => {
  const els = document.querySelectorAll('.tcig');
  
  if(els){
    els.forEach(el => {
      // Animate in
      ScrollTrigger.create({
        trigger: el,
        start: `center bottom`,
        end: `center top`,
        onEnter: () => {
          el.classList.remove('uninitialized');
        },
        onEnterBack: () => {
          el.classList.remove('uninitialized');
        }
      });

      // Keep track of height for mobile styling
      const setHeight = () => {
        const height = el.getBoundingClientRect().height;
        el.style.setProperty('--block-height', Math.round(height) + 'px');
      }
      setHeight();

      window.addEventListener('resize', setHeight);
    });
  };
}
